// extracted by mini-css-extract-plugin
export default {"link":"YK-z","disabled":"ZK-z"};